import type { CSSProperties } from "react";
import { Icon } from "../Icon";
import { OUTBOUND_STAGES, STAGE_LABEL } from "../../../domain/stages";
import { lazyList } from "../../../i18n/localized";

const DEFAULT_STAGES = lazyList(OUTBOUND_STAGES.length, (i) => STAGE_LABEL[OUTBOUND_STAGES[i]!]);

export function Pipeline({
  current,
  stages = DEFAULT_STAGES,
  times = [],
  failedAt,
  complete = false,
}: {
  current: number;
  stages?: readonly string[];
  times?: (string | null)[];
  failedAt?: number;
  /** The document has finished at `current`: that step is done, not in progress. */
  complete?: boolean;
}) {
  const at = Math.min(Math.max(current, 0), stages.length - 1);
  return (
    <div className="pipe">
      {stages.map((s, i) => {
        // a failure stops progress: everything past failedAt stays todo
        let cls = "todo";
        if (failedAt !== undefined) {
          if (i === failedAt) cls = "fail";
          else if (i < failedAt) cls = "done";
        } else if (i < at || (complete && i === at)) cls = "done";
        else if (i === at) cls = "active";
        return (
          <div className={`pipe-step ${cls}`} style={{ "--i": i } as CSSProperties} key={i}>
            <div className="pipe-rail">
              <i />
            </div>
            <div className="pipe-meta">
              <div className="pipe-name">
                {cls === "done" ? <Icon name="check" className="pipe-check" /> : null}
                {cls === "fail" ? <Icon name="x" className="pipe-check" /> : null}
                {s}
              </div>
              {times[i] ? <div className="pipe-time">{times[i]}</div> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
